import { queryOptions } from '@tanstack/react-query';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';
import { QueryKeys } from 'utils/queryKeys';

export const approvalQueries = {
  state: (contentId: string, accountId: number, userId: number) =>
    queryOptions({
      queryKey: QueryKeys.getDocumentApprovalState(contentId, accountId, userId),
      queryFn: () => apiDocumentServiceRepository.getDocumentApprovalState(contentId),
      staleTime: 0,
      refetchOnWindowFocus: 'always',
    }),
};
